/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SendReactionRequestDto { 
    /**
     * id чата
     */
    chatId: string;
    /**
     * id сообщения, на которое идет ответ в виде реакции
     */
    replyMessageId: string;
    /**
     * Эмодзи для реакции
     */
    emodjiName: string;
}

